export default {
  0: { showImage: false },
  1: { showImage: true, showAnnounce: true },
};
